import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-error",
  "use": "icon-icon-error-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon-error\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#ED4F4F\" cx=\"6\" cy=\"6\" r=\"6\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"m4.398 8.626 4.294-4.195L7.62 3.32 3.304 7.49z\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"m3.345 4.374 4.196 4.294 1.11-1.072L4.482 3.28z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol